/**
 * @generated SignedSource<<0ada3594a737f97ceb2f48f6811b5b08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateContentLabelInput = {
  contentLabelId: string;
  label: string;
};
export type ContentLabelUpdateForm_UpdateLabelMutation$variables = {
  input: UpdateContentLabelInput;
};
export type ContentLabelUpdateForm_UpdateLabelMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly contents: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly label: string;
          };
        }>;
      };
      readonly id: string;
      readonly label: string;
    } | null;
  };
};
export type ContentLabelUpdateForm_UpdateLabelMutation = {
  response: ContentLabelUpdateForm_UpdateLabelMutation$data;
  variables: ContentLabelUpdateForm_UpdateLabelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateContentLabelMutationResponse",
    "kind": "LinkedField",
    "name": "updateContentLabel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ContentLabel",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentNodeConnection",
            "kind": "LinkedField",
            "name": "contents",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentLabelUpdateForm_UpdateLabelMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentLabelUpdateForm_UpdateLabelMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "b2e62db406a7d5a5feee16a634f42c80",
    "id": null,
    "metadata": {},
    "name": "ContentLabelUpdateForm_UpdateLabelMutation",
    "operationKind": "mutation",
    "text": "mutation ContentLabelUpdateForm_UpdateLabelMutation(\n  $input: UpdateContentLabelInput!\n) {\n  response: updateContentLabel(input: $input) {\n    node {\n      id\n      label\n      contents {\n        edges {\n          node {\n            id\n            label\n          }\n        }\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "13958fc3ccdf92c14d88a1d3dde886eb";

export default node;
